import type { OpalApiV3Component } from '../../../schema'
import type { FlattenedCustomField } from './types'

export const systemTypeToIcon: Record<string, string> = {
  textarea: 'gem-text',
  url: 'gem-link',
  date: 'gem-calendar-today',
  singleSelect: 'gem-single-choice',
  multiSelect: 'gem-multiple-choice',
  usersSelect: 'gem-users',
}

export const systemTypeToLabel: Record<string, string> = {
  textarea: 'Text',
  url: 'URL',
  date: 'Date Picker',
  singleSelect: 'Single Choice Dropdown',
  multiSelect: 'Multiple Choice Dropdown',
  usersSelect: 'People',
}

/**
  Represents the list of words which aren't allowed to be
  used as Custom Field names. Note that these reserved words
  should stay in parity with the backend `CustomFieldReservedNames`
  found in `custom_field_reserved_names.ex`.
**/
export const reservedCustomFieldNames: string[] = [
  'assignee',
  'calendar date',
  'date',
  'description',
  'end date',
  'image',
  'label',
  'labels',
  'name',
  'note',
  'start date',
  'status',
  'story',
  'swimlane',
  'type',
  'workflow',
]

export const getMetadataForCustomField = (field: FlattenedCustomField) => {
  if (field.type === 'singleSelect' || field.type === 'multiSelect') {
    type SelectMetadata = Extract<
      OpalApiV3Component<'custom_field'>['attributes']['metadata'],
      { options: object }
    >

    return field.metadata as SelectMetadata
  }
}
